import { api } from '../../DefaultService';
import { IActiveSoftCreateProps, IActiveSoftProps, IActiveSoftUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/activeSoft';

export const createActiveSoftIntegrationAsync = async (
  data: IActiveSoftCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllActiveSoftIntegrationsAsync = async (): Promise<
  IActiveSoftProps[]
> => {
  return await api
    .get<IActiveSoftProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getActiveSoftIntegrationByIdAsync = async (
  id: number,
): Promise<IActiveSoftProps> => {
  return await api
    .get<IActiveSoftProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateActiveSoftIntegrationAsync = async ({
  id,
  data,
}: IActiveSoftUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteActiveSoftIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
